export interface WorkItem {
  id: string;
  title: string;
  type: string;
  year: number;
  cover: string;
  summary: string;
  director: string;
  producer: string;
  duration: string;
  popularity: number;
  description: string[];
  highlights: string[];
  gallery: string[];
}

export const workTypes = ["全部", "影视项目", "广告案例", "节目作品"];

export const works: WorkItem[] = [
  {
    id: "1",
    title: "《山海之间》",
    type: "影视项目",
    year: 2025,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20mountains%20and%20sea%20at%20golden%20hour%2C%20dramatic%20orange%20sky%2C%20silhouette%20of%20a%20lone%20figure%2C%20moody%20cinematic%20lighting%2C%20warm%20tones%2C%20no%20text%2C%20high%20detail&width=800&height=1100&seq=mango-work-01&orientation=portrait",
    summary: "一部聚焦沿海家族三代人命运的史诗剧集，斩获年度最佳剧集提名。",
    director: "林承宇",
    producer: "芒果传媒影视中心",
    duration: "12 集 / 45 分钟",
    popularity: 98,
    description: [
      "《山海之间》以东南沿海的一座渔港小镇为背景，讲述陈家三代人在时代浪潮中的抉择与守望。剧集以细腻的镜头语言刻画普通人的坚韧，用影像记录中国沿海地区四十年的变迁。",
      "项目历时 18 个月筹备，横跨三个省份实景拍摄，动用了行业内顶尖的水下摄影团队与航拍团队，力求真实还原海洋场景的壮阔与人物情感的细腻。",
    ],
    highlights: ["实景拍摄，跨越三省取景", "原创剧本打磨 26 稿", "专业水下摄影团队参与制作", "入围多项年度影视评选"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Cinematic%20fishing%20village%20coastline%20at%20sunset%2C%20warm%20orange%20golden%20light%2C%20dramatic%20sky%2C%20film%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-01-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Film%20crew%20shooting%20on%20location%20by%20the%20sea%20at%20dusk%2C%20cinematic%20behind%20the%20scenes%2C%20warm%20tones%2C%20professional%20production&width=1200&height=700&seq=mango-work-01-b&orientation=landscape",
    ],
  },
  {
    id: "2",
    title: "《城市脉搏》",
    type: "影视项目",
    year: 2025,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20night%20cityscape%20poster%2C%20neon%20warm%20orange%20lights%2C%20rain%20slicked%20streets%2C%20moody%20atmosphere%2C%20film%20poster%20style%2C%20no%20text%2C%20high%20detail&width=800&height=1100&seq=mango-work-02&orientation=portrait",
    summary: "都市悬疑剧集，以一座超大城市为舞台，揭开隐藏于霓虹之下的真相。",
    director: "苏晚",
    producer: "芒果传媒影视中心",
    duration: "16 集 / 50 分钟",
    popularity: 95,
    description: [
      "《城市脉搏》以都市悬疑为外壳，探讨现代都市人的孤独与连接。剧集采用多线叙事结构，将六位主角的命运交织于同一个夜晚，节奏紧凑、反转不断。",
      "摄影团队使用大量城市实景与长镜头调度，营造出沉浸式的都市氛围，配乐由知名作曲家量身定制。",
    ],
    highlights: ["多线叙事结构，节奏紧凑", "全实景都市取景", "知名作曲家原创配乐", "上线首周播放量破亿"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20warm%20neon%20reflections%2C%20cinematic%20film%20still%2C%20moody%2C%20orange%20tones%2C%20no%20text&width=1200&height=700&seq=mango-work-02-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20city%20skyline%20at%20blue%20hour%20with%20warm%20windows%20glowing%2C%20aerial%20view%2C%20film%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-02-b&orientation=landscape",
    ],
  },
  {
    id: "3",
    title: "《风起南洋》",
    type: "影视项目",
    year: 2024,
    cover: "https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20film%20poster%2C%20tropical%20southeast%20asia%20setting%2C%20warm%20amber%20sunlight%2C%20traditional%20architecture%2C%20cinematic%20grand%20scale%2C%20no%20text&width=800&height=1100&seq=mango-work-03&orientation=portrait",
    summary: "年代传奇大剧，讲述华侨家族在异国他乡的奋斗与归来。",
    director: "陈嘉树",
    producer: "芒果传媒影视中心",
    duration: "36 集 / 45 分钟",
    popularity: 91,
    description: [
      "《风起南洋》横跨南洋与中国大陆两地取景，以宏大叙事展现华侨家族的百年浮沉，是一部兼具历史厚度与情感温度的年代大剧。",
      "剧组搭建了超过 3 万平方米的实景基地，服饰与道具考据严谨，还原了那个时代的风貌。",
    ],
    highlights: ["横跨两地取景拍摄", "36000 平米实景基地", "服饰道具严谨考据", "年代剧口碑标杆之作"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Historic%20tropical%20colonial%20street%20with%20warm%20sunlight%2C%20cinematic%20film%20still%2C%20amber%20tones%2C%20no%20text&width=1200&height=700&seq=mango-work-03-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Traditional%20chinese%20courtyard%20in%20golden%20afternoon%20light%2C%20cinematic%20period%20drama%20still%2C%20warm%20tones%2C%20no%20text&width=1200&height=700&seq=mango-work-03-b&orientation=landscape",
    ],
  },
  {
    id: "4",
    title: "「晨光」品牌形象片",
    type: "广告案例",
    year: 2025,
    cover: "https://readdy.ai/api/search-image?query=Minimal%20brand%20commercial%20poster%2C%20soft%20morning%20light%20through%20curtains%2C%20warm%20cream%20tones%2C%20elegant%20product%20photography%2C%20no%20text&width=800&height=1100&seq=mango-work-04&orientation=portrait",
    summary: "为高端生活方式品牌打造的形象广告，用光影讲述晨间仪式感。",
    director: "周叙",
    producer: "芒果传媒广告制作部",
    duration: "60 秒 / 30 秒 / 15 秒",
    popularity: 87,
    description: [
      "本片以清晨的第一缕光为线索，将产品自然融入生活场景，传递品牌「温柔且坚定」的价值主张。",
      "全片在上海与杭州两地拍摄，采用自然光为主、人工光为辅的布光方案，画面通透而有质感。",
    ],
    highlights: ["自然光主导的布光方案", "多版本剪辑适配全渠道", "品牌调性高度统一", "投放后品牌搜索量显著提升"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Soft%20morning%20light%20in%20minimal%20bright%20interior%2C%20warm%20cream%20tones%2C%20product%20commercial%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-04-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20product%20scene%20on%20wooden%20table%20with%20warm%20sunlight%2C%20commercial%20photography%2C%20no%20text&width=1200&height=700&seq=mango-work-04-b&orientation=landscape",
    ],
  },
  {
    id: "5",
    title: "「山海行」文旅宣传片",
    type: "广告案例",
    year: 2024,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20tourism%20promo%20poster%2C%20vast%20mountains%20meeting%20the%20ocean%2C%20warm%20aerial%20golden%20light%2C%20majestic%20landscape%2C%20no%20text&width=800&height=1100&seq=mango-work-05&orientation=portrait",
    summary: "城市文旅形象宣传片，以航拍视角展现山海之城的壮美与人文。",
    director: "高远",
    producer: "芒果传媒广告制作部",
    duration: "4 分钟 / 90 秒",
    popularity: 84,
    description: [
      "宣传片以「山海相逢」为主题，通过四组人物的日常故事串联起城市的风貌，既有壮阔的航拍大景，也有温暖的人间烟火。",
      "拍摄团队累计航拍飞行超过 120 小时，覆盖城市 30 余处地标与人文场景。",
    ],
    highlights: ["120 小时航拍素材", "覆盖 30 余处地标", "人文与风光并重", "多平台投放传播"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20coastline%20where%20mountains%20meet%20ocean%20at%20golden%20hour%2C%20cinematic%20tourism%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-05-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Warm%20aerial%20city%20view%20at%20sunrise%20with%20mountains%20in%20background%2C%20cinematic%20promo%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-05-b&orientation=landscape",
    ],
  },
  {
    id: "6",
    title: "《寻味山海》",
    type: "节目作品",
    year: 2025,
    cover: "https://readdy.ai/api/search-image?query=Food%20documentary%20show%20poster%2C%20rustic%20kitchen%20with%20warm%20firelight%2C%20fresh%20local%20ingredients%2C%20warm%20amber%20tones%2C%20no%20text&width=800&height=1100&seq=mango-work-06&orientation=portrait",
    summary: "美食人文纪录片综艺，跟随主厨走访山海之间，探寻食物的本源。",
    director: "李昀",
    producer: "芒果传媒节目中心",
    duration: "10 期 / 40 分钟",
    popularity: 93,
    description: [
      "《寻味山海》将美食与人文结合，每期深入一个地域，从食材的源头讲到餐桌上的故事，用食物串联起人与土地的情感。",
      "节目采用纪实拍摄手法，保留大量现场原声与环境音，营造出真实而治愈的氛围。",
    ],
    highlights: ["纪实拍摄手法", "深入原产地溯源", "口碑评分持续走高", "带动地方文旅关注"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Rustic%20open%20fire%20cooking%20scene%20with%20fresh%20ingredients%2C%20warm%20amber%20tones%2C%20documentary%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-06-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fresh%20local%20produce%20on%20a%20wooden%20table%20in%20warm%20natural%20light%2C%20food%20documentary%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-06-b&orientation=landscape",
    ],
  },
  {
    id: "7",
    title: "《舞台之上》",
    type: "节目作品",
    year: 2024,
    cover: "https://readdy.ai/api/search-image?query=Live%20performance%20stage%20show%20poster%2C%20warm%20spotlight%20on%20empty%20stage%2C%20dramatic%20theatrical%20lighting%2C%20amber%20tones%2C%20no%20text&width=800&height=1100&seq=mango-work-07&orientation=portrait",
    summary: "大型舞台竞演综艺，聚焦新生代表演者，以舞台见证成长。",
    director: "沈弋",
    producer: "芒果传媒节目中心",
    duration: "12 期 / 90 分钟",
    popularity: 89,
    description: [
      "《舞台之上》搭建了国内领先的沉浸式舞台，集结数十位新锐表演者同台竞演，通过专业的声光电设计呈现一场场视觉盛宴。",
      "节目邀请行业资深导师全程指导，既有竞技的紧张感，也有成长的温度。",
    ],
    highlights: ["沉浸式舞台设计", "行业资深导师阵容", "声光电一体化呈现", "多期话题登上热搜"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Dramatic%20stage%20with%20warm%20spotlight%20beams%20and%20smoke%2C%20theatrical%20lighting%2C%20concert%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-07-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20immersive%20performance%20stage%20from%20audience%20view%2C%20warm%20stage%20lights%2C%20no%20text&width=1200&height=700&seq=mango-work-07-b&orientation=landscape",
    ],
  },
  {
    id: "8",
    title: "「逐光者」科技品牌片",
    type: "广告案例",
    year: 2023,
    cover: "https://readdy.ai/api/search-image?query=Technology%20brand%20commercial%20poster%2C%20abstract%20warm%20light%20rays%20and%20geometric%20shapes%2C%20futuristic%20minimal%20design%2C%20amber%20tones%2C%20no%20text&width=800&height=1100&seq=mango-work-08&orientation=portrait",
    summary: "科技品牌年度形象片，用抽象光影语言诠释「逐光而行」的探索精神。",
    director: "周叙",
    producer: "芒果传媒广告制作部",
    duration: "90 秒 / 45 秒",
    popularity: 80,
    description: [
      "本片融合实拍与三维视觉特效，以光的运动为核心视觉母题，呈现出科技品牌对未来探索的想象。",
      "制作团队自主开发了部分动态视觉模板，为品牌后续传播提供了可复用的视觉资产。",
    ],
    highlights: ["实拍与三维特效融合", "自主研发视觉模板", "可复用品牌视觉资产", "国际广告节入围"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20light%20rays%20and%20geometric%20shapes%20in%20dark%20space%2C%20futuristic%20minimal%20visual%2C%20no%20text&width=1200&height=700&seq=mango-work-08-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Technology%20concept%20visual%20with%20glowing%20amber%20particles%20and%20light%20beam%2C%20abstract%2C%20no%20text&width=1200&height=700&seq=mango-work-08-b&orientation=landscape",
    ],
  },
  {
    id: "9",
    title: "《长夜灯明》",
    type: "影视项目",
    year: 2023,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20warm%20lit%20window%20in%20a%20quiet%20night%20town%2C%20lonely%20atmosphere%2C%20warm%20amber%20light%2C%20no%20text&width=800&height=1100&seq=mango-work-09&orientation=portrait",
    summary: "文艺剧情长片，讲述小镇教师与留守孩子们在长夜中相互照亮的温柔故事。",
    director: "林承宇",
    producer: "芒果传媒影视中心",
    duration: "118 分钟",
    popularity: 82,
    description: [
      "《长夜灯明》是一部安静的文艺长片，没有激烈的冲突，只有在漫长冬夜里缓慢生长的温情。影片以克制而诗意的镜头，记录下一段平凡却动人的师生情。",
      "影片入围多个国际电影节展映单元，被评价为「一部需要静下心来感受的作品」。",
    ],
    highlights: ["文艺剧情长片", "国际电影节入围", "克制诗意的镜头语言", "质朴真实的表演"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Quiet%20snowy%20small%20town%20at%20night%20with%20warm%20window%20lights%2C%20cinematic%20film%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-09-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Warm%20lit%20classroom%20in%20evening%20with%20empty%20desks%2C%20cinematic%20still%2C%20nostalgic%20tones%2C%20no%20text&width=1200&height=700&seq=mango-work-09-b&orientation=landscape",
    ],
  },
  {
    id: "10",
    title: "《声生不息》",
    type: "节目作品",
    year: 2023,
    cover: "https://readdy.ai/api/search-image?query=Music%20show%20poster%2C%20warm%20stage%20lights%20and%20silhouette%20of%20a%20microphone%2C%20intimate%20live%20music%20atmosphere%2C%20amber%20tones%2C%20no%20text&width=800&height=1100&seq=mango-work-10&orientation=portrait",
    summary: "音乐文化交流节目，让不同年代的经典旋律在舞台上重新相遇。",
    director: "沈弋",
    producer: "芒果传媒节目中心",
    duration: "10 期 / 80 分钟",
    popularity: 86,
    description: [
      "《声生不息》邀请不同世代的歌手同台合作，重新演绎经典作品，探讨音乐如何跨越时间连接人心。",
      "节目的现场录音采用高标准制作，发行原声专辑后获得广泛好评。",
    ],
    highlights: ["跨世代歌手合作", "高标准现场录音", "发行官方原声专辑", "经典作品焕发新生"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Intimate%20live%20music%20stage%20with%20warm%20lights%20and%20microphone%20stand%2C%20concert%20still%2C%20no%20text&width=1200&height=700&seq=mango-work-10-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Warm%20recording%20studio%20session%20with%20instruments%2C%20music%20production%20still%2C%20amber%20tones%2C%20no%20text&width=1200&height=700&seq=mango-work-10-b&orientation=landscape",
    ],
  },
];